import SideNav from "../SideNav/SideNav";

function Ticket() {

    return (
        <div id="wrap-body">
            <div class="heading-group page-name color-w">
                <h1>Ticket System</h1>
                <div class="intro">
                    <p>A state-of-the-art dining ticket system for our memory care units offer various format options (Standard, Select, Advanced Select Menu and Point of Service). POS Select Menu tickets are generated by tableside and/or room service requests via a tablet, iPad or Android device. These resident selections can be prepared immediately by using hard copy tickets or implementing our paperless Dining Ticket system. All formats include diet icons, pictures of residents, pictures of adaptive devices, etc. that integrate with other system modules to generate various reports.</p>
                </div>
                <div class="star-group">
                    <i class="fa fa-star-o"></i>
                    <i class="fa fa-star-o star-1x"></i>
                    <i class="fa fa-star-o"></i>
                </div>
            </div>
            <div class="container" id="main-content">
                <div class="reservation">
                    <div class="title">Ticket System
                        <h3>Highlights</h3>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <ul class="custom_list">
                                <li>Totally integrated with all system modules to eliminate duplicate entries.</li>
                                <li>Dining tickets can be set up to offer a simplified format or detailed formats.</li>
                                <li>Four dining ticket options are available for the different levels of care/dining experience.</li>
                                <li>Standard dining tickets with the below features display color coded likes/dislikes.</li>
                                <li>Select Menu dining tickets display diet specific regular and alternate menu item food options.</li>
                                <li>Advanced Select Menu dining tickets include regular, alternate &amp; always available menu items. </li>
                                <li>Point of Service Select Menu dining tickets allow a server to use a tablet, iPad or Android device to take resident menu selections at the table (or bedside) to generate dining tickets with resident choices.</li>
                                <li>All dining ticket options include resident images or silhouettes for staff to become more familiar with the ones they serve.</li>
                                <li>All dining ticket options include diet and thickened liquids icons to assist in the plate setup and assure diet compliance/efficiency.</li>
                                <li>All dining ticket options include images of adaptive devices to remind staff of the proper equipment needed for each resident plate.</li>
                                <li>All dining tickets have multiple print options that can be customized per community.</li>
                                <li>All dining ticket data fields (diets, likes/dislikes, beverages, adaptive devices, snacks &amp; supplements) have default settings and allows users to edit settings to meet their needs.</li>
                                <li>The resident record is integrated and updates other modules to generate supplement manager reports, supplement labels, various production reports, census data, and food-labor ppd reports.</li>
                            </ul>
                        </div>
                        <SideNav/>
                    </div>
                </div>
            </div>
        </div>    
    );


}

export default Ticket;